// Máquinas e frota leve no Mapa (14/10/2026): camadas, abas, grade, faixa de coleta
// e o balão da unidade, que é HTML puro e lê as chaves pelo i18next.
export default {
  pt: {
    'mapa.unidades.camadaMaquinas': 'Máquinas',
    'mapa.unidades.camadaFrotaLeve': 'Frota leve',
    'mapa.unidades.mostrarMaquinas': 'Mostrar as máquinas no mapa',
    'mapa.unidades.mostrarFrotaLeve': 'Mostrar a frota leve no mapa',
    'mapa.unidades.contagemMaquinas_one': '{{count}} máquina com posição',
    'mapa.unidades.contagemMaquinas_other': '{{count}} máquinas com posição',
    'mapa.unidades.contagemFrotaLeve_one': '{{count}} veículo com posição',
    'mapa.unidades.contagemFrotaLeve_other': '{{count}} veículos com posição',
    'mapa.unidades.contagemFiltrada': '{{shown}} de {{count}} na área visível',

    'mapa.unidades.abasAria': 'Listas do mapa',
    'mapa.unidades.abaFrota': 'Frota pesada',
    'mapa.unidades.abaMaquinas': 'Máquinas',
    'mapa.unidades.abaFrotaLeve': 'Frota leve',

    'mapa.unidades.contagem': '{{shown}} de {{total}}',
    'mapa.unidades.filtro.maquina': 'Máquina',
    'mapa.unidades.filtro.operador': 'Operador',
    'mapa.unidades.filtro.placa': 'Placa',
    'mapa.unidades.filtro.modelo': 'Modelo',
    'mapa.unidades.filtro.contrato': 'Contrato',
    'mapa.unidades.filtro.classificacao': 'Classificação',
    'mapa.unidades.filtro.cliente': 'Cliente',
    'mapa.unidades.filtro.sinal': 'Sinal',
    'mapa.unidades.filtro.ignicao': 'Ignição',
    'mapa.unidades.filtro.buscar': 'Buscar',
    'mapa.unidades.semMotorista': 'Sem motorista',
    'mapa.unidades.semOperador': 'Sem operador',
    'mapa.unidades.semProgramacao': 'Sem programação hoje',
    'mapa.unidades.semProgramacaoDica': 'Sem programação de colheita hoje: cliente, contrato e operador ficam em branco',
    'mapa.unidades.vazioMaquinas': 'Nenhuma máquina com os filtros escolhidos.',
    'mapa.unidades.vazioFrotaLeve': 'Nenhum veículo com os filtros escolhidos. Só aparece o veículo com a Classificação preenchida no cadastro de Frota.',
    'mapa.unidades.localizar': 'Localizar {{label}} no mapa',
    'mapa.unidades.semPosicao': 'Sem posição para localizar',
    'mapa.unidades.abrirNoMaps': 'Abrir {{label}} no Google Maps',
    'mapa.unidades.semPosicaoMaps': 'Sem posição para abrir no Google Maps',
    'mapa.unidades.semCadastro': 'Sem cadastro',
    'mapa.unidades.semCadastroDica': 'O rastreador não casou com nenhum veículo do cadastro de Frota do HUB',
    'mapa.unidades.ambiguo': 'Ambíguo',
    'mapa.unidades.ambiguoDica': 'Mais de um veículo do cadastro casa com este rastreador; o vínculo espera a operação decidir',

    'mapa.unidades.col.tipo': 'Tipo',
    'mapa.unidades.col.maquina': 'Máquina',
    'mapa.unidades.col.placa': 'Placa',
    'mapa.unidades.col.modelo': 'Modelo',
    'mapa.unidades.col.cliente': 'Cliente',
    'mapa.unidades.col.operador': 'Operador',
    'mapa.unidades.col.contrato': 'Contrato',
    'mapa.unidades.col.motoristaConjunto': 'Motorista Conjunto',
    'mapa.unidades.col.motoristaAtual': 'Motorista Atual',
    'mapa.unidades.col.local': 'Local',
    'mapa.unidades.col.sinal': 'Sinal',
    'mapa.unidades.col.ignicao': 'Ignição',
    'mapa.unidades.col.velocidade': 'Velocidade',
    'mapa.unidades.col.ultimaMensagem': 'Última mensagem',
    'mapa.unidades.col.ultimaAtualizacao': 'Última atualização',

    'mapa.unidades.sinal.transmitindo': 'Transmitindo',
    'mapa.unidades.sinal.atrasado': 'Atrasado',
    'mapa.unidades.sinal.sem_sinal': 'Sem sinal',
    'mapa.unidades.sinal.nunca': 'Nunca transmitiu',
    'mapa.unidades.ignicao.ligada': 'Ligada',
    'mapa.unidades.ignicao.desligada': 'Desligada',
    'mapa.unidades.ignicao.desconhecida': 'Desconhecida',
    'mapa.unidades.ha': 'há {{tempo}}',
    'mapa.unidades.agora': 'agora',
    'mapa.unidades.semSinalHa': 'Sem sinal há {{tempo}}',
    'mapa.unidades.ultimaMensagemHa': 'Última mensagem há {{tempo}}',
    'mapa.unidades.ignicaoLigadaHa': 'Ligada há {{tempo}}',
    'mapa.unidades.ignicaoDesligadaHa': 'Desligada há {{tempo}}',

    'mapa.unidades.popup.maquina': 'Máquina',
    'mapa.unidades.popup.utilitario': 'Frota leve',
    'mapa.unidades.popup.codigo': 'Código',
    'mapa.unidades.popup.placa': 'Placa',
    'mapa.unidades.popup.modelo': 'Modelo',
    'mapa.unidades.popup.cliente': 'Cliente',
    'mapa.unidades.popup.contrato': 'Contrato',
    'mapa.unidades.popup.frente': 'Frente',
    'mapa.unidades.popup.operador': 'Operador',
    'mapa.unidades.popup.tipo': 'Tipo',
    'mapa.unidades.popup.semProgramacao': 'Sem programação de colheita hoje',
    'mapa.unidades.popup.motoristaConjunto': 'Motorista Conjunto',
    'mapa.unidades.popup.motoristaAtual': 'Motorista Atual',
    'mapa.unidades.popup.abrirNoMaps': 'Abrir no Google Maps',
    'mapa.unidades.popup.sinal': 'Sinal',
    'mapa.unidades.popup.ignicao': 'Ignição',
    'mapa.unidades.popup.velocidade': 'Velocidade',
    'mapa.unidades.popup.endereco': 'Endereço',
    'mapa.unidades.popup.posicaoEm': 'Última posição',
    'mapa.unidades.popup.semCadastro': 'Sem cadastro no HUB',
    'mapa.unidades.popup.verRastro': 'Ver o rastro de hoje',
    'mapa.unidades.classificacao.operador': 'Operador',
    'mapa.unidades.classificacao.operador_fixo': 'Operador fixo',
    'mapa.unidades.classificacao.mecanico_colheita': 'Mecânico colheita',
    'mapa.unidades.classificacao.caminhao_manutencao_colheita': 'Caminhão manutenção colheita',
    'mapa.unidades.classificacao.manutencao_transporte': 'Manutenção transporte',
    'mapa.unidades.classificacao.caminhao_manutencao_transporte': 'Caminhão manutenção transporte',
    'mapa.unidades.classificacao.apoio_garagem': 'Apoio garagem',

    'mapa.unidades.coleta.aria': 'Situação da coleta',
    'mapa.unidades.coleta.ligada': 'Coleta ligada',
    'mapa.unidades.coleta.desligada': 'Coleta desligada',
    'mapa.unidades.coleta.ultima': 'Última coleta',
    'mapa.unidades.coleta.nenhuma': 'nenhuma ainda',
    'mapa.unidades.coleta.unidades': 'Unidades',
    'mapa.unidades.coleta.comPosicao': 'Com posição',
    'mapa.unidades.coleta.vinculadas': 'No cadastro',
    'mapa.unidades.coleta.vinculadasDica': 'Unidades ligadas a um veículo do cadastro de Frota do HUB',
    'mapa.unidades.coleta.transmitindo': 'Transmitindo',
    'mapa.unidades.coleta.transmitindoDica': 'Mandaram mensagem nos últimos 10 minutos',
    'mapa.unidades.coleta.ultimoErro': 'Último erro',
    'mapa.unidades.coleta.erroHttp': 'HTTP {{http}}',
    'mapa.unidades.coleta.fornecedor.ssx': 'SSX',
    'mapa.unidades.coleta.fornecedor.aldeia': 'Aldeia',

    'mapa.rastro.vazioUnidade': 'Sem posições gravadas no período.',
  },
  en: {
    'mapa.unidades.camadaMaquinas': 'Machines',
    'mapa.unidades.camadaFrotaLeve': 'Light fleet',
    'mapa.unidades.mostrarMaquinas': 'Show machines on the map',
    'mapa.unidades.mostrarFrotaLeve': 'Show the light fleet on the map',
    'mapa.unidades.contagemMaquinas_one': '{{count}} machine with a position',
    'mapa.unidades.contagemMaquinas_other': '{{count}} machines with a position',
    'mapa.unidades.contagemFrotaLeve_one': '{{count}} vehicle with a position',
    'mapa.unidades.contagemFrotaLeve_other': '{{count}} vehicles with a position',
    'mapa.unidades.contagemFiltrada': '{{shown}} of {{count}} in the visible area',

    'mapa.unidades.abasAria': 'Map lists',
    'mapa.unidades.abaFrota': 'Heavy fleet',
    'mapa.unidades.abaMaquinas': 'Machines',
    'mapa.unidades.abaFrotaLeve': 'Light fleet',

    'mapa.unidades.contagem': '{{shown}} of {{total}}',
    'mapa.unidades.filtro.maquina': 'Machine',
    'mapa.unidades.filtro.operador': 'Operator',
    'mapa.unidades.filtro.placa': 'Plate',
    'mapa.unidades.filtro.modelo': 'Model',
    'mapa.unidades.filtro.contrato': 'Contract',
    'mapa.unidades.filtro.classificacao': 'Classification',
    'mapa.unidades.filtro.cliente': 'Customer',
    'mapa.unidades.filtro.sinal': 'Signal',
    'mapa.unidades.filtro.ignicao': 'Ignition',
    'mapa.unidades.filtro.buscar': 'Search',
    'mapa.unidades.semMotorista': 'No driver',
    'mapa.unidades.semOperador': 'No operator',
    'mapa.unidades.semProgramacao': 'No schedule today',
    'mapa.unidades.semProgramacaoDica': 'No harvest schedule today: customer, contract and operator stay blank',
    'mapa.unidades.vazioMaquinas': 'No machine matches the selected filters.',
    'mapa.unidades.vazioFrotaLeve': 'No vehicle matches the selected filters. Only vehicles with a Classification in the Fleet register are shown.',
    'mapa.unidades.localizar': 'Locate {{label}} on the map',
    'mapa.unidades.semPosicao': 'No position to locate',
    'mapa.unidades.abrirNoMaps': 'Open {{label}} in Google Maps',
    'mapa.unidades.semPosicaoMaps': 'No position to open in Google Maps',
    'mapa.unidades.semCadastro': 'Not registered',
    'mapa.unidades.semCadastroDica': 'The tracker did not match any vehicle in the HUB fleet registry',
    'mapa.unidades.ambiguo': 'Ambiguous',
    'mapa.unidades.ambiguoDica': 'More than one registered vehicle matches this tracker; the link waits for the operation to decide',

    'mapa.unidades.col.tipo': 'Type',
    'mapa.unidades.col.maquina': 'Machine',
    'mapa.unidades.col.placa': 'Plate',
    'mapa.unidades.col.modelo': 'Model',
    'mapa.unidades.col.cliente': 'Customer',
    'mapa.unidades.col.operador': 'Operator',
    'mapa.unidades.col.contrato': 'Contract',
    'mapa.unidades.col.motoristaConjunto': 'Assigned driver',
    'mapa.unidades.col.motoristaAtual': 'Current driver',
    'mapa.unidades.col.local': 'Location',
    'mapa.unidades.col.sinal': 'Signal',
    'mapa.unidades.col.ignicao': 'Ignition',
    'mapa.unidades.col.velocidade': 'Speed',
    'mapa.unidades.col.ultimaMensagem': 'Last message',
    'mapa.unidades.col.ultimaAtualizacao': 'Last update',

    'mapa.unidades.sinal.transmitindo': 'Transmitting',
    'mapa.unidades.sinal.atrasado': 'Delayed',
    'mapa.unidades.sinal.sem_sinal': 'No signal',
    'mapa.unidades.sinal.nunca': 'Never transmitted',
    'mapa.unidades.ignicao.ligada': 'On',
    'mapa.unidades.ignicao.desligada': 'Off',
    'mapa.unidades.ignicao.desconhecida': 'Unknown',
    'mapa.unidades.ha': '{{tempo}} ago',
    'mapa.unidades.agora': 'now',
    'mapa.unidades.semSinalHa': 'No signal for {{tempo}}',
    'mapa.unidades.ultimaMensagemHa': 'Last message {{tempo}} ago',
    'mapa.unidades.ignicaoLigadaHa': 'On for {{tempo}}',
    'mapa.unidades.ignicaoDesligadaHa': 'Off for {{tempo}}',

    'mapa.unidades.popup.maquina': 'Machine',
    'mapa.unidades.popup.utilitario': 'Light fleet',
    'mapa.unidades.popup.codigo': 'Code',
    'mapa.unidades.popup.placa': 'Plate',
    'mapa.unidades.popup.modelo': 'Model',
    'mapa.unidades.popup.cliente': 'Customer',
    'mapa.unidades.popup.contrato': 'Contract',
    'mapa.unidades.popup.frente': 'Front',
    'mapa.unidades.popup.operador': 'Operator',
    'mapa.unidades.popup.tipo': 'Type',
    'mapa.unidades.popup.semProgramacao': 'No harvest schedule today',
    'mapa.unidades.popup.motoristaConjunto': 'Assigned driver',
    'mapa.unidades.popup.motoristaAtual': 'Current driver',
    'mapa.unidades.popup.abrirNoMaps': 'Open in Google Maps',
    'mapa.unidades.popup.sinal': 'Signal',
    'mapa.unidades.popup.ignicao': 'Ignition',
    'mapa.unidades.popup.velocidade': 'Speed',
    'mapa.unidades.popup.endereco': 'Address',
    'mapa.unidades.popup.posicaoEm': 'Last position',
    'mapa.unidades.popup.semCadastro': 'Not registered in the HUB',
    'mapa.unidades.popup.verRastro': 'View today\'s trail',
    'mapa.unidades.classificacao.operador': 'Operator',
    'mapa.unidades.classificacao.operador_fixo': 'Fixed operator',
    'mapa.unidades.classificacao.mecanico_colheita': 'Harvest mechanic',
    'mapa.unidades.classificacao.caminhao_manutencao_colheita': 'Harvest maintenance truck',
    'mapa.unidades.classificacao.manutencao_transporte': 'Transport maintenance',
    'mapa.unidades.classificacao.caminhao_manutencao_transporte': 'Transport maintenance truck',
    'mapa.unidades.classificacao.apoio_garagem': 'Garage support',

    'mapa.unidades.coleta.aria': 'Collection status',
    'mapa.unidades.coleta.ligada': 'Collection on',
    'mapa.unidades.coleta.desligada': 'Collection off',
    'mapa.unidades.coleta.ultima': 'Last collection',
    'mapa.unidades.coleta.nenhuma': 'none yet',
    'mapa.unidades.coleta.unidades': 'Units',
    'mapa.unidades.coleta.comPosicao': 'With position',
    'mapa.unidades.coleta.vinculadas': 'Registered',
    'mapa.unidades.coleta.vinculadasDica': 'Units linked to a vehicle in the HUB fleet registry',
    'mapa.unidades.coleta.transmitindo': 'Transmitting',
    'mapa.unidades.coleta.transmitindoDica': 'Sent a message in the last 10 minutes',
    'mapa.unidades.coleta.ultimoErro': 'Last error',
    'mapa.unidades.coleta.erroHttp': 'HTTP {{http}}',
    'mapa.unidades.coleta.fornecedor.ssx': 'SSX',
    'mapa.unidades.coleta.fornecedor.aldeia': 'Aldeia',

    'mapa.rastro.vazioUnidade': 'No positions recorded in the period.',
  },
  es: {
    'mapa.unidades.camadaMaquinas': 'Máquinas',
    'mapa.unidades.camadaFrotaLeve': 'Flota liviana',
    'mapa.unidades.mostrarMaquinas': 'Mostrar las máquinas en el mapa',
    'mapa.unidades.mostrarFrotaLeve': 'Mostrar la flota liviana en el mapa',
    'mapa.unidades.contagemMaquinas_one': '{{count}} máquina con posición',
    'mapa.unidades.contagemMaquinas_other': '{{count}} máquinas con posición',
    'mapa.unidades.contagemFrotaLeve_one': '{{count}} vehículo con posición',
    'mapa.unidades.contagemFrotaLeve_other': '{{count}} vehículos con posición',
    'mapa.unidades.contagemFiltrada': '{{shown}} de {{count}} en el área visible',

    'mapa.unidades.abasAria': 'Listas del mapa',
    'mapa.unidades.abaFrota': 'Flota pesada',
    'mapa.unidades.abaMaquinas': 'Máquinas',
    'mapa.unidades.abaFrotaLeve': 'Flota liviana',

    'mapa.unidades.contagem': '{{shown}} de {{total}}',
    'mapa.unidades.filtro.maquina': 'Máquina',
    'mapa.unidades.filtro.operador': 'Operador',
    'mapa.unidades.filtro.placa': 'Placa',
    'mapa.unidades.filtro.modelo': 'Modelo',
    'mapa.unidades.filtro.contrato': 'Contrato',
    'mapa.unidades.filtro.classificacao': 'Clasificación',
    'mapa.unidades.filtro.cliente': 'Cliente',
    'mapa.unidades.filtro.sinal': 'Señal',
    'mapa.unidades.filtro.ignicao': 'Encendido',
    'mapa.unidades.filtro.buscar': 'Buscar',
    'mapa.unidades.semMotorista': 'Sin conductor',
    'mapa.unidades.semOperador': 'Sin operador',
    'mapa.unidades.semProgramacao': 'Sin programación hoy',
    'mapa.unidades.semProgramacaoDica': 'Sin programación de cosecha hoy: cliente, contrato y operador quedan en blanco',
    'mapa.unidades.vazioMaquinas': 'Ninguna máquina con los filtros elegidos.',
    'mapa.unidades.vazioFrotaLeve': 'Ningún vehículo con los filtros elegidos. Solo aparece el vehículo con la Clasificación cargada en el registro de Flota.',
    'mapa.unidades.localizar': 'Ubicar {{label}} en el mapa',
    'mapa.unidades.semPosicao': 'Sin posición para ubicar',
    'mapa.unidades.abrirNoMaps': 'Abrir {{label}} en Google Maps',
    'mapa.unidades.semPosicaoMaps': 'Sin posición para abrir en Google Maps',
    'mapa.unidades.semCadastro': 'Sin registro',
    'mapa.unidades.semCadastroDica': 'El rastreador no coincidió con ningún vehículo del registro de Flota del HUB',
    'mapa.unidades.ambiguo': 'Ambiguo',
    'mapa.unidades.ambiguoDica': 'Más de un vehículo del registro coincide con este rastreador; el vínculo espera la decisión de la operación',

    'mapa.unidades.col.tipo': 'Tipo',
    'mapa.unidades.col.maquina': 'Máquina',
    'mapa.unidades.col.placa': 'Placa',
    'mapa.unidades.col.modelo': 'Modelo',
    'mapa.unidades.col.cliente': 'Cliente',
    'mapa.unidades.col.operador': 'Operador',
    'mapa.unidades.col.contrato': 'Contrato',
    'mapa.unidades.col.motoristaConjunto': 'Conductor del conjunto',
    'mapa.unidades.col.motoristaAtual': 'Conductor actual',
    'mapa.unidades.col.local': 'Ubicación',
    'mapa.unidades.col.sinal': 'Señal',
    'mapa.unidades.col.ignicao': 'Encendido',
    'mapa.unidades.col.velocidade': 'Velocidad',
    'mapa.unidades.col.ultimaMensagem': 'Último mensaje',
    'mapa.unidades.col.ultimaAtualizacao': 'Última actualización',

    'mapa.unidades.sinal.transmitindo': 'Transmitiendo',
    'mapa.unidades.sinal.atrasado': 'Atrasado',
    'mapa.unidades.sinal.sem_sinal': 'Sin señal',
    'mapa.unidades.sinal.nunca': 'Nunca transmitió',
    'mapa.unidades.ignicao.ligada': 'Encendido',
    'mapa.unidades.ignicao.desligada': 'Apagado',
    'mapa.unidades.ignicao.desconhecida': 'Desconocido',
    'mapa.unidades.ha': 'hace {{tempo}}',
    'mapa.unidades.agora': 'ahora',
    'mapa.unidades.semSinalHa': 'Sin señal hace {{tempo}}',
    'mapa.unidades.ultimaMensagemHa': 'Último mensaje hace {{tempo}}',
    'mapa.unidades.ignicaoLigadaHa': 'Encendido hace {{tempo}}',
    'mapa.unidades.ignicaoDesligadaHa': 'Apagado hace {{tempo}}',

    'mapa.unidades.popup.maquina': 'Máquina',
    'mapa.unidades.popup.utilitario': 'Flota liviana',
    'mapa.unidades.popup.codigo': 'Código',
    'mapa.unidades.popup.placa': 'Placa',
    'mapa.unidades.popup.modelo': 'Modelo',
    'mapa.unidades.popup.cliente': 'Cliente',
    'mapa.unidades.popup.contrato': 'Contrato',
    'mapa.unidades.popup.frente': 'Frente',
    'mapa.unidades.popup.operador': 'Operador',
    'mapa.unidades.popup.tipo': 'Tipo',
    'mapa.unidades.popup.semProgramacao': 'Sin programación de cosecha hoy',
    'mapa.unidades.popup.motoristaConjunto': 'Conductor del conjunto',
    'mapa.unidades.popup.motoristaAtual': 'Conductor actual',
    'mapa.unidades.popup.abrirNoMaps': 'Abrir en Google Maps',
    'mapa.unidades.popup.sinal': 'Señal',
    'mapa.unidades.popup.ignicao': 'Encendido',
    'mapa.unidades.popup.velocidade': 'Velocidad',
    'mapa.unidades.popup.endereco': 'Dirección',
    'mapa.unidades.popup.posicaoEm': 'Última posición',
    'mapa.unidades.popup.semCadastro': 'Sin registro en el HUB',
    'mapa.unidades.popup.verRastro': 'Ver el rastro de hoy',
    'mapa.unidades.classificacao.operador': 'Operador',
    'mapa.unidades.classificacao.operador_fixo': 'Operador fijo',
    'mapa.unidades.classificacao.mecanico_colheita': 'Mecánico de cosecha',
    'mapa.unidades.classificacao.caminhao_manutencao_colheita': 'Camión de mantenimiento de cosecha',
    'mapa.unidades.classificacao.manutencao_transporte': 'Mantenimiento de transporte',
    'mapa.unidades.classificacao.caminhao_manutencao_transporte': 'Camión de mantenimiento de transporte',
    'mapa.unidades.classificacao.apoio_garagem': 'Apoyo garaje',

    'mapa.unidades.coleta.aria': 'Situación de la recolección',
    'mapa.unidades.coleta.ligada': 'Recolección encendida',
    'mapa.unidades.coleta.desligada': 'Recolección apagada',
    'mapa.unidades.coleta.ultima': 'Última recolección',
    'mapa.unidades.coleta.nenhuma': 'ninguna todavía',
    'mapa.unidades.coleta.unidades': 'Unidades',
    'mapa.unidades.coleta.comPosicao': 'Con posición',
    'mapa.unidades.coleta.vinculadas': 'En el registro',
    'mapa.unidades.coleta.vinculadasDica': 'Unidades vinculadas a un vehículo del registro de Flota del HUB',
    'mapa.unidades.coleta.transmitindo': 'Transmitiendo',
    'mapa.unidades.coleta.transmitindoDica': 'Enviaron mensaje en los últimos 10 minutos',
    'mapa.unidades.coleta.ultimoErro': 'Último error',
    'mapa.unidades.coleta.erroHttp': 'HTTP {{http}}',
    'mapa.unidades.coleta.fornecedor.ssx': 'SSX',
    'mapa.unidades.coleta.fornecedor.aldeia': 'Aldeia',

    'mapa.rastro.vazioUnidade': 'Sin posiciones registradas en el período.',
  },
}
